function configureDarkModePreference() {
  const root = document.documentElement;

  if (matchMedia('(prefers-color-scheme: dark)').matches) {
    root.classList.add('sl-theme-dark');
    root.setAttribute('data-bs-theme', 'dark');
  } else {
    root.classList.remove('sl-theme-dark');
    root.removeAttribute('data-bs-theme');
  }
}

configureDarkModePreference();

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', configureDarkModePreference);

